export const BASELINE = 16;
export const NEXT_SECTION_HINT_ROWS = 2;
export const MIN_HOME_HEIGHT = 480;


/** WEBPACK FOOTER **
 ** ./src/js/variables.js
 **/